import { useLayoutEffect } from "react";
import { useLocation } from "react-router";

const ScrollToTop = ({ scrollElementRef }: { scrollElementRef: React.RefObject<HTMLElement | null> }) => {
  const location = useLocation();

  // We can use built-in ScrollRestoration if they ever fix
  // https://github.com/remix-run/react-router/discussions/9495
  useLayoutEffect(() => {
    if (scrollElementRef.current) {
      scrollElementRef.current.scrollTo(0, 0);
    }
  }, [scrollElementRef, location.pathname]);

  return null;
};

export default ScrollToTop;
